export default "__VITE_ASSET__JwaBKRfS__"